import { render, staticRenderFns } from "./accessDetailsRow.vue?vue&type=template&id=bdb6fff4&"
import script from "./accessDetailsRow.vue?vue&type=script&lang=js&"
export * from "./accessDetailsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports